import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { EntityObject, PageRequest, PageResult } from "../../common/types";
import { HistoryLog } from "./types";

const GET_HISTORY_LOG_FOR_AGENT = ApiRequestAdapter.create("/agents/{0}/history-logs", HttpMethod.GET);
const GET_HISTORY_LOG_FOR_CONTRACT = ApiRequestAdapter.create("/contracts/{0}/history-logs", HttpMethod.GET);

export const historyLogApi = {
  getHistoryLogForAgent: (request: EntityObject<PageRequest>): AxiosPromise<PageResult<HistoryLog>> => {
    return apiService.get(GET_HISTORY_LOG_FOR_AGENT.getParametrizedUrl(request.id), { params: request.object });
  },
  getHistoryLogForContract: (request: EntityObject<PageRequest>): AxiosPromise<PageResult<HistoryLog>> => {
    return apiService.get(GET_HISTORY_LOG_FOR_CONTRACT.getParametrizedUrl(request.id), { params: request.object });
  },
};
